import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const API_BASE = "https://api.dev1.auth.joeandalese.com/v1";

function HomePage({ token: propToken }) {
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${API_BASE}/me`, { credentials: "include" })
      .then(r => r.ok ? r.json() : Promise.reject(r.status))
      .then(data => setEmail(data.email || ""))
      .catch(() => navigate("/"));
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: 40 }}>
      <h1>Welcome {email}</h1>
      <div style={{ display: "flex", flexDirection: "column", gap: 12, alignItems: "center", marginTop: 24 }}>
        <Link to="/photos" style={{ fontSize: 18, color: "#1976d2", textDecoration: "underline" }}>View Photos</Link>
        <Link to="/account" style={{ fontSize: 18, color: "#1976d2", textDecoration: "underline" }}>Account Management</Link>
      </div>
    </div>
  );
}

export default HomePage;
